import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ReactiveComponentModule } from '@ngrx/component';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';

import { MoodDescriptionDialogComponent } from './mood-description-dialog.component';

@NgModule({
	declarations: [MoodDescriptionDialogComponent],
	imports: [
		CommonModule,
		TranslateModule,
		DropdownModule,
		ButtonModule,
		ReactiveComponentModule,
		ReactiveFormsModule,
	],
	exports: [MoodDescriptionDialogComponent],
})
export class MoodDescriptionDialogModule {}
